<template>
  <div>
    <b-button
      variant="primary"
      class="ml-auto mr-1"
      :disabled="loader"
      @click="triggerFileInput"
    >
      Import Template
    </b-button>

    <!-- Hidden file input -->
    <b-form-file
      ref="fileInput"
      v-model="templateData"
      accept=".xlsx"
      class="d-none"
      @input="editTemplatesHalal"
    />
  </div>
</template>
<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      loader: false,
      templateData: null,
    }
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.$el.querySelector('input').click()
    },

    editTemplatesHalal() {
      if (!this.templateData) return

      this.loader = true

      const formData = new FormData()
      formData.append('file', this.templateData)

      axios
        .post('manufacture-white-lists/template-import', formData)
        .then(() => {
          this.$toasted.show('Imported Successfully', {
            position: 'top-center',
            duration: 3000,
          })
          this.templateData = null
        })
        .catch(err => {
          const error = decryptData(err?.response?.data?.payload)
          this.$toasted.show(error?.message?.file[0] || 'Upload failed', {
            position: 'top-center',
            duration: 3000,
          })
        })
        .finally(() => {
          this.loader = false
        })
    },
  },
}
</script>
